var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M16,8.3c0-0.6-0.4-1-1-1h-2h-0.9H7.9H7H5c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h10  c0.6,0,1-0.4,1-1V8.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_185_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    stroke: "#FFFFFF",
    d: "M12.5,8.8c-0.3,0-0.5-0.2-0.5-0.5V5.8c0-0.3-0.2-0.5-0.5-0.5h-3C8.2,5.3,8,5.5,8,5.8v2.5   c0,0.3-0.2,0.5-0.5,0.5S7,8.6,7,8.3V5.8C7,5,7.7,4.3,8.5,4.3h3C12.3,4.3,13,5,13,5.8v2.5C13,8.6,12.8,8.8,12.5,8.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.23aa3eff8c8c6d5270b26d6f9972ffc4.svg";
export { ForwardRef as ReactComponent };